export const SET_BUCKETS = "SET_BUCKETS";
export const SET_CREATED_BUCKET = "SET_CREATED_BUCKET";
export const SET_UPDATED_BUCKET = "SET_UPDATED_BUCKET";
export const REMOVE_DELETED_BUCKET = "REMOVE_DELETED_BUCKET";
export const SET_BUCKET_ERROR = "SET_BUCKET_ERROR";
export const SET_BUCKETS_LOADING = "SET_BUCKETS_LOADING";
export const SET_BUCKETS_FETCHING = "SET_BUCKETS_FETCHING";
